import { render, staticRenderFns } from "./OqsCell.vue?vue&type=template&id=78f16e6c&"
import script from "./OqsCell.vue?vue&type=script&lang=js&"
export * from "./OqsCell.vue?vue&type=script&lang=js&"
import style0 from "./OqsCell.vue?vue&type=style&index=0&id=78f16e6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports